import { Controller } from "@hotwired/stimulus"

// Wizard de 2 pasos del modal "Crear landing":
//   Step 1 (init)      → titulo + descripcion
//   Step 2 (templates) → grid de templates con radios
//
// Estructura visual: cada step es un <div data-target="stepXxx"> con su propio
// `step_modal(title:, back:)` dentro (replica el patron del SII wizard). Los
// headers (titulo + back button) los genera el helper `step_modal`, no hay
// manipulacion manual de targets de titulo ni back button.
//
// La navegacion AVANZADA (Siguiente) va server-side: el boton "Siguiente" hace
// submit parcial con `name="step" value="1"`, el Form Object valida title via
// `step_1?`, y el turbo_stream re-renderiza el partial con `step: :templates`
// (cuando OK) o con `step: :init` + errores inline via `form_field` (cuando fail).
//
// La navegacion HACIA ATRAS es client-side (no necesita validacion):
// `goBack()` alterna las clases `hidden` de los wrappers stepInit/stepTemplates.
// Como el back button vive dentro del step visible, al ocultar el step su back
// button tambien queda oculto naturalmente — Stimulus no necesita togglearlo.
//
// Ademas sincroniza el badge visible de cada card (default / black) segun cual
// radio este checked.
export default class extends Controller {
  static targets = [
    "stepInit",
    "stepTemplates",
    "templateCard",
    "badgeDefault",
    "badgeSelected"
  ]

  connect() {
    this.syncCards()
  }

  // Detiene la propagacion del evento `turbo:submit-end` cuando el submit fue
  // del boton "Siguiente" (step 1), para evitar que el modal controller
  // (`manage--modal`) cierre el modal en response exitoso. El submit del
  // boton "Crear" (step 2) sí deja propagar — el modal se cierra y
  // `render_turbo_navigate` navega a la config page.
  handleSubmitEnd(event) {
    const submitter = event.detail && event.detail.formSubmission
      ? event.detail.formSubmission.submitter
      : null
    if (submitter && submitter.name === "step" && submitter.value === "1") {
      event.stopPropagation()
    }
  }

  goBack(event) {
    event.preventDefault()
    this.show(this.stepTemplatesTarget, false)
    this.show(this.stepInitTarget, true)
  }

  syncCards() {
    this.templateCardTargets.forEach((card, idx) => {
      const radio = card.querySelector('input[type="radio"]')
      const isChecked = radio && radio.checked
      const badgeDefault = this.badgeDefaultTargets[idx]
      const badgeSelected = this.badgeSelectedTargets[idx]
      if (badgeDefault) this.show(badgeDefault, !isChecked)
      if (badgeSelected) this.show(badgeSelected, isChecked)
    })
  }

  show(element, visible) {
    if (!element) return
    element.classList.toggle("hidden", !visible)
  }
}
